import React, { FC } from 'react';
import Modal from 'react-bootstrap/Modal';
import { createUseStyles } from 'react-jss';
import { Button, ButtonVariant, Typography } from '@packages/ui/shared';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export interface PublicationModalProps {
    show: boolean;
    footer?: boolean;
    title: string;
    bodyHeader?: string;
    bodyContent?: string;
    confirmButton?: string;
    confirmButtonLoading: boolean;
    confirmButtonDisable?: boolean;
    cancelButton?: string;
    discardButton?: string;
    onHideModal: () => void;
    handleCancelAction: () => void;
    handleConfirmAction: () => void;
    handleDiscardAction?: () => void;
    closeButton?: boolean;
    variant: ButtonVariant;
}

const useStyles = createUseStyles({
    modalLayer: {
        zIndex: 1065,
    },
    backdropLayer: {
        zIndex: 1060,
    },
});

export const PublicationModal: FC<PublicationModalProps> = ({
    show,
    title,
    bodyHeader,
    bodyContent,
    cancelButton,
    confirmButton,
    confirmButtonLoading,
    discardButton,
    footer = true,
    handleCancelAction,
    handleConfirmAction,
    handleDiscardAction,
    onHideModal,
    closeButton,
    confirmButtonDisable,
    variant,
}) => {
    const classes = useStyles();

    return (
        <Modal
            show={show}
            centered={true}
            onHide={onHideModal}
            className={classes.modalLayer}
            backdropClassName={classes.backdropLayer}
        >
            {title && (
                <Modal.Header closeButton={closeButton}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}

            <Modal.Body>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {bodyHeader && <Typography variant="caption4">{bodyHeader}</Typography>}
                    {bodyContent && (
                        <Typography variant="caption4" style={{ fontWeight: 400 }}>
                            {bodyContent}
                        </Typography>
                    )}
                </div>
            </Modal.Body>

            {footer && (
                <Modal.Footer style={{ justifyContent: discardButton ? 'space-between' : '' }}>
                    {discardButton && (
                        <Button variant="ghost-blue" onPress={handleDiscardAction} style={{ marginRight: 5 }}>
                            {discardButton}
                        </Button>
                    )}

                    <div style={{ display: 'flex' }}>
                        {cancelButton && (
                            <Button variant="ghost-blue" onPress={handleCancelAction} style={{ marginRight: 5 }}>
                                {cancelButton}
                            </Button>
                        )}

                        {confirmButton &&
                            (confirmButtonDisable ? (
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                        <Tooltip
                                            id={'1'}
                                            style={{
                                                fontSize: 16,
                                                padding: '8px 12px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {'Please enter Title and Publication Type'}
                                        </Tooltip>
                                    }
                                >
                                    <span>
                                        <Button variant={variant} style={{ pointerEvents: 'none' }} disabled>
                                            {confirmButton}
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    variant={variant}
                                    onPress={handleConfirmAction}
                                    isLoading={confirmButtonLoading}
                                    disabled={confirmButtonLoading || confirmButtonDisable}
                                >
                                    {confirmButton}
                                </Button>
                            ))}
                    </div>
                </Modal.Footer>
            )}
        </Modal>
    );
};
